import { render, staticRenderFns } from "./BuyerAccountBudget.vue?vue&type=template&id=7c92ceee&scoped=true"
import script from "./BuyerAccountBudget.vue?vue&type=script&lang=js"
export * from "./BuyerAccountBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c92ceee",
  null
  
)

export default component.exports